import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/denuncias';

export default {
    fetchDenuncias(filtro, data) {
        let query =
            baseUrl + `/listagem?page=${filtro.page}&size=${filtro.size}`;

        let filtroType = filtro.sort === 'idDenuncia' ? 'id' : 'resultado';

        if (filtro.sort && filtro.por) {
            query += `&sort=${filtroType},${filtro.por}`;
        }

        return http.post({
            url: query,
            data,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.carregando')
        });
    },

    atualizaDataAceitacao() {
        return http.put({
            url: baseUrl + '/aceitacao',
            data: {
                dataAceite: new Date()
            },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.carregando')
        });
    },

    consultarDenuncias(data) {
        return http.post({
            url: `${baseUrl}/consultar-denuncias`,
            data,
            lockScreen: true
        });
    }
};
